import { Pipe, PipeTransform } from '@angular/core';
import { Payment } from '../../api/models';
import { AuthService } from '../../guards/services/auth.service';

@Pipe({
  name: 'paymentAmount',
})
export class PaymentAmountPipe implements PipeTransform {
  // payment | paymentAmount:travel.customer_pay_fees
  transform(value: Payment, ...args: boolean[]): number {
    const feesOnCustomer = args[0];

    if (!feesOnCustomer) {
      return value.amount;
    } else {
      return (value.amount * 100) / 103; //toglie il 3%
      //return value.amount * 1.03; // aggiunge il 3%
    }
  }
}
